import { createSelector } from '@reduxjs/toolkit'

export const makeFileSelectorIsSearching = () => createSelector(
  (state) => state.templates,
  (slice) => {
    const { isSearching } = slice
    return isSearching
  }
)

export const makeFileSelectorSearchResults = () => createSelector(
  (state) => state.templates,
  (slice) => {
    const { searchResults } = slice
    return searchResults
  }
)
